<div>
    <div
        [ngClass]="{'my-schedule-header':true,'my-schedule-header-background':mysessionConfig.hasOwnProperty('my_schedule'),'my-session-header-background':!mysessionConfig.hasOwnProperty('my_schedule')}"
>
        <h3>
            <i role="presentation" class="fa fa-lg" [ngClass]="['fa-calendar']"></i>
            <span [ngClass]="{'my-schedule-header-label': mysessionConfig.hasOwnProperty('my_schedule'),'my-session-header-label':!mysessionConfig.hasOwnProperty('my_schedule')}" id="my-schedule-label">
                {{ mysessionConfig.my_schedule.my_schedule_header.label }}
            </span>
        </h3>
    </div>
    <div class="my-schedule-body">
        <div class="my-schedule-container">
            <div *ngIf="options && sharedService.showMyScheduleCalendar" class="my-schedule-tab-content">
                <button class="c-btn c-btn--primary--download_calendar my-sessions-download-calendar" id="download-calendar-label" type="button" (click)="downloadMySessionCalendar()">
                    <i class="fa fa-download"></i>
                    <span>Download Calendar</span>
                </button>

                <ccl-date-picker
                    [dateOptions]="dateOptions"
                    (valueChange)="changeCalendarDate($event)"
                    style="visibility: hidden"
                    id="datePicker"
                ></ccl-date-picker>

                <ng-fullcalendar
                    #mySchedule
                    [options]="options"
                    (eventClick)="eventClick($event.detail)"
                    (eventRender)="eventrender($event.detail)"
                ></ng-fullcalendar>
            </div>
            <div id="tool-tip-event" *ngIf="isHidden" class="visible-hide">
                <span [innerHTML]="eventDetail | safeHtml"></span>
            </div>
        </div>
    </div>
    <div class="my-schedule-footer">
        <button [ngClass]="{'c-btn c-btn--primary':true,'my-schedule-button-primary':mysessionConfig.hasOwnProperty('my_schedule'),'my-session-button-primary': !mysessionConfig.hasOwnProperty('my_schedule')}"
        id="done-label" (click)="closeMySchedule()">
            {{ 'my_schedule.done' | translate }}
        </button>
    </div>
</div>
